<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :model="formParameter"
        :inline="true"
        label-width="80px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始生效" prop="starttm">
              <el-date-picker
                v-model="formParameter.starttm"
                type="date"
                disabled
                placeholder="有效期至"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endtm">
              <el-date-picker
                v-model="formParameter.endtm"
                type="date"
                disabled
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="文件内容:" prop="content"  v-if="contentHTML"    >
                   <div v-html="contentHTML"></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="close"  >关  闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import roleTree from '@/components/biz/roleTree/roleTree.vue';
import selectRoleTreeDialog from '@/components/biz/selectRoleTreeDialog/selectRoleTreeDialog.vue';
import wangEdit2 from "@/components/wangEdit/wangEditReadOnly.vue";

export default {
  name: "detail",
  components: {
    popup,
    selectOptionDictionary,
    wangEdit2,
	  roleTree,
	  selectRoleTreeDialog
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      parameter: {},
      formParameter: {},
      contentHTML:''
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.contentHTML=""
      this.formParameter = parameter;
      this.$refs.popup.open(title, "75%");
      this.contentHTML =   this.formParameter.content
      this.disabled = disabled
      this.popupLoading = false
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.contentHTML=""
      this.$refs.popup.close();
      this.popupLoading = false
    },
   
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

  .content-html {
     border: 1px solid #c9d8db !important;
     padding: 4px;
   }
 

</style>
